import { render, staticRenderFns } from "./Yearplan.vue?vue&type=template&id=42b47d0c&"
import script from "./Yearplan.vue?vue&type=script&lang=ts&"
export * from "./Yearplan.vue?vue&type=script&lang=ts&"
import style0 from "./Yearplan.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports